import { render } from "./ConfirmProductModal.vue?vue&type=template&id=59e3c4c4&ts=true"
import script from "./ConfirmProductModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmProductModal.vue?vue&type=script&lang=ts"

import "./ConfirmProductModal.vue?vue&type=style&index=0&id=59e3c4c4&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__